exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".split-dropdown-button-container-7dBPcWJnmwr{display:inline-flex;align-items:stretch}.split-dropdown-button-primary-action-2a1ifLwNmwr{border-top-right-radius:0;border-bottom-right-radius:0}.split-dropdown-button-secondary-action-7bRwr93Bmwr{border-top-left-radius:0;border-bottom-left-radius:0;min-width:0;border-left:1px solid rgba(0,0,0,0.08);padding-left:6px;padding-right:6px}.split-dropdown-button-secondary-action-7bRwr93Bmwr.split-dropdown-button-xsmall-6uRlZZiHmwr{padding-left:2px;padding-right:2px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"container": "split-dropdown-button-container-7dBPcWJnmwr",
	"primary-action": "split-dropdown-button-primary-action-2a1ifLwNmwr",
	"primaryAction": "split-dropdown-button-primary-action-2a1ifLwNmwr",
	"secondary-action": "split-dropdown-button-secondary-action-7bRwr93Bmwr",
	"secondaryAction": "split-dropdown-button-secondary-action-7bRwr93Bmwr",
	"xsmall": "split-dropdown-button-xsmall-6uRlZZiHmwr"
};